import template from './form.html';
import { FormActions } from 'core/services/form';
import giftcardsI18N from 'i18n/giftcards/es.json';
import commonI18N from 'i18n/common/es.json';
import { rest } from 'core/api';
import configFile from 'config.json';
import { formatErrorMessage } from 'core/util';

export let GiftcardFormComponent = {
  templateUrl: template,
  selector: 'giftcardForm',
  bindings: {
    view: '<',
    translations: '='
  },
  controller: FormController,
  controllerAs: 'vm'
};

export const translationKeys = Object.keys(giftcardsI18N).concat(Object.keys(commonI18N));


FormController.$inject = ['$state', '$ngRedux', 'ngNotify', '$stateParams', 'Filter', '$scope', '$timeout', 'BasicFactory', '$filter'];

function FormController($state, $ngRedux, ngNotify, $stateParams, Filter, $scope, $timeout, BasicFactory, $filter) {
  this.defaultDateFormat = configFile.defaultDateFormat;

  this.cancel = cancel.bind(this);
  this.doSubmit = doSubmit.bind(this);
  this.handleStatus = handleStatus.bind(this);
  this.mapStateToThis = mapStateToThis.bind(this);
  let unsubscribe;
  const monedasFilter = Filter.path('tipo.codigo').eq('moneda')
    .or(Filter.path('tipo.codigo').eq('estado_giftcard'))
    .or(Filter.path('tipo.codigo').eq('tipo_giftcard'));

  this.$onDestroy = () => {
    this.form();
    unsubscribe();
    $ngRedux.dispatch(rest.actions.valores.reset());
  };

  this.localModel = {
    inicioOptions: {},
    finOptions: {}
  };


  function onChangeDate() {
    if (this.model) {
      this.localModel.inicioOptions.maxDate = this.model.vigenciaFin;
      this.localModel.finOptions.minDate = this.model.vigenciaInicio;
    }
  }


  this.$onInit = () => {
    unsubscribe = $ngRedux.connect(this.mapStateToThis, FormActions)(this);

    if ($stateParams.uid) {
      this.title = this.view ? this.translations['Ver giftcard'] : this.translations['Editar giftcard'];
      this.formEdit('giftcards', $stateParams.uid);
    } else {
      this.title = this.translations['Nuevo giftcard'];
      this.form();
    }
    $ngRedux.dispatch(rest.actions.valores.get({ filter: JSON.stringify(monedasFilter) }));
  };

  function mapStateToThis(state) {
    this.handleStatus(state);
    this.submitted = state.form.flags ? state.form.flags.submitted : false;
    this.model = state.form.model;

    if (!this.model.id && state.valores.data && state.valores.data.length > 0) {
      this.model.moneda = state.valores.data.filter(v => v.value === 'Guaraníes')[0];
      this.estados = state.valores.data.filter(v => v.tipo.codigo === 'estado_giftcard');
      this.tipos = state.valores.data.filter(v => v.tipo.codigo === 'tipo_giftcard');
      this.model.codigo = 'Autogenerado al guardar';
      this.model.vigenciaInicio = new Date();
      let unAnhoMas = new Date();
      unAnhoMas.setDate(unAnhoMas.getDate() + 365);
      this.model.vigenciaFin = unAnhoMas;
    } else if (this.model.id && !this.modelInit) {
      this.modelInit = true;

      this.model.ordenesDeTrabajo.forEach((orden)=>{setMontoOrden(orden)});

      if (typeof this.model.vigenciaInicio.getMonth === 'function') {
        this.model.vigenciaInicio = this.model.vigenciaInicio;
      } else {
        this.model.vigenciaInicio = moment(this.model.vigenciaInicio, 'DD/MM/YYYY').toDate();
      }
      if (typeof this.model.vigenciaFin.getMonth === 'function') {
        this.model.vigenciaFin = this.model.vigenciaFin;
      } else {
        this.model.vigenciaFin = moment(this.model.vigenciaFin, 'DD/MM/YYYY').toDate();
      }

      this.onChangeDate();
    }

    return {
      form: state.form
    };
  }

  this.loadProductos = loadProductos.bind(this);
  this.renderProducto = renderProducto.bind(this);
  this.onChangeDate = onChangeDate.bind(this);
  this.onSelectServicio = onSelectServicio.bind(this);

  function onSelectServicio() {
    this.model.monto = this.model.servicio.precio.monto;
  }

  this.filterPrecio = filterPrecio.bind(this);

  function filterPrecio(servicio) {
    return servicio.precio;
  }

  function loadProductos(query) {
    let filter = Filter.path('categoria.clase.value').eq('Servicio');

    if (query) {
      filter = filter.and(Filter.path('nombre').like(query));
    }

    BasicFactory.setup('productos');
    return BasicFactory.all({ filter: JSON.stringify(filter) });
  }

  function renderProducto(item) {
    return `${item.nombre}`;
  }

  /**
   * Función que se encarga de mostrar mensajes de error/exito en base al estado actual
   * 
   * @param {object} state
   */
  function handleStatus(state) {
    if (state.form.notFound) {
      const msg = `${this.translations['No existe el elemento con ID']} ${$stateParams.uid}`;
      ngNotify.set(msg, 'warn');
      $timeout(() => $state.go('home.giftcards.list'));
      return;
    }

    if (state.form.error) {
      ngNotify.set(formatErrorMessage(state.form.error.message), { type: 'error', html: true });
    }

    if (state.form.created) {
      ngNotify.set(this.translations['Datos guardados correctamente'], 'success');
      $state.go('home.giftcards.list');
    }
  }


  /**
   * Cancela el formulario y retorna al listado
   */
  function cancel() {
    $state.go('home.giftcards.list');
  }

  function doSubmit() {
    if ($scope.giftcardForm.$invalid) {
      this.submitted = true;
      return;
    }

    let data = Object.assign({}, this.model);
    if (data.servicio) {
      data.servicio = { id: data.servicio.id };
    }

    if (data.id && (data.estado.value === 'Habilitada' || data.estado.value === 'Disponible Venta')) {
      data.montoRestante = data.monto;
    }

    let vigenciaInicio;
    let vigenciaFin;

    if (typeof data.vigenciaInicio.getMonth === 'function') {
      vigenciaInicio = data.vigenciaInicio;
    } else {
      vigenciaInicio = moment(data.vigenciaInicio, 'DD/MM/YYYY').toDate();
    }
    if (typeof data.vigenciaFin.getMonth === 'function') {
      vigenciaFin = data.vigenciaFin;
    } else {
      vigenciaFin = moment(data.vigenciaFin, 'DD/MM/YYYY').toDate();
    }

    if (vigenciaInicio > vigenciaFin) {
      ngNotify.set(this.translations['Rango fecha Inicio/Fin invalido'], 'warn');
      return;
    }

    this.save('giftcards', data);
  }

  this.onTipoChange = onTipoChange.bind(this);
  function onTipoChange() {
    if (this.model.tipo.value === 'Monto' && this.model.servicio) {
      this.model.servicio = null;
    }     
  }

  this.setMontoOrden = setMontoOrden.bind(this);
  function setMontoOrden(orden) {
    // Calcular el monto total de una urden orden
    // Monto base del servicio
    let monto = orden.servicio.precio.monto;
    // Sumar montos de adicionales, etc.
    orden.detalles.forEach(function(detalle) {
      monto += detalle.monto;
    });

    orden.monto = monto;
  }

  this.renderMonto = renderMonto.bind(this);
  function renderMonto(detalle) {
    return $filter('currency')(detalle.monto, 'Gs.', 0);;
  }
}


// WEBPACK FOOTER //
// ./src/components/giftcards/form/form.component.js